import React, { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    Button,
    Paper,
    TextField,
    Link,
    Divider
} from '@mui/material';
import WindowIcon from '@mui/icons-material/Window';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const LoginPage = ({ isClient = false }) => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        if (accounts.length > 0) {
            navigate('/admin');
        }
    }, [accounts, navigate]);

    const handleLogin = () => {
        instance.loginRedirect({
            ...loginRequest,
            redirectStartPage: `${window.location.origin}/admin`
        }).catch((e) => {
            console.error('Erro no login Microsoft:', e);
        });
    };

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'radial-gradient(circle at center, #1a1a1a 0%, #000000 100%)',
                color: 'white',
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    background: 'rgba(255, 255, 255, 0.03)',
                    backdropFilter: 'blur(20px)',
                    padding: { xs: 4, sm: 8 }, // 32px to 64px (Antigravity Tokens)
                    borderRadius: '14px', // Standard industrial square
                    textAlign: 'center',
                    maxWidth: '440px',
                    width: '100%',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    color: 'white',
                    m: 2
                }}
            >
                <Typography variant="h4" sx={{ color: 'white', mb: 3, fontWeight: 600, mt: 1 }}>
                    {isClient ? 'Portal do Cliente' : 'Portal de Gestão R5id'}
                </Typography>

                <Box component="form" noValidate autoComplete="off" sx={{ width: '100%', mb: 3 }}>
                    <TextField
                        fullWidth
                        placeholder="Usuário"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            '& .MuiOutlinedInput-root': {
                                color: 'white',
                                borderRadius: '14px', // Square Standard
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
                                '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.4)' },
                                '&.Mui-focused fieldset': { borderColor: '#0078D4' },
                            },
                            '& input::placeholder': { color: 'grey.500', opacity: 1 }
                        }}
                    />
                    <TextField
                        fullWidth
                        type="password"
                        placeholder="Senha"
                        variant="outlined"
                        sx={{
                            mb: 1,
                            '& .MuiOutlinedInput-root': {
                                color: 'white',
                                borderRadius: '14px', // Square Standard
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
                                '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.4)' },
                                '&.Mui-focused fieldset': { borderColor: '#0078D4' },
                            },
                            '& input::placeholder': { color: 'grey.500', opacity: 1 }
                        }}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
                        <Link
                            component="button"
                            type="button"
                            underline="hover"
                            onClick={(e) => e.preventDefault()}
                            sx={{ color: 'grey.500', fontSize: '0.85rem', cursor: 'pointer' }}
                        >
                            Esqueci a senha
                        </Link>
                    </Box>

                    <Button
                        fullWidth
                        variant="outlined"
                        endIcon={<ArrowForwardIcon />}
                        sx={{
                            py: 1.5,
                            borderRadius: '14px', // Square Standard
                            borderColor: 'white',
                            color: 'white',
                            fontWeight: 600,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            '&:hover': {
                                backgroundColor: 'white',
                                color: 'black',
                                borderColor: 'white'
                            }
                        }}
                    >
                        ENTRAR
                    </Button>
                </Box>

                {!isClient && (
                    <>
                        <Divider sx={{ mb: 3, borderColor: 'rgba(255,255,255,0.1)', width: '100%' }}>
                            <Typography variant="caption" sx={{ color: 'grey.600' }}>OU</Typography>
                        </Divider>

                        <Button
                            onClick={handleLogin}
                            variant="contained"
                            startIcon={<WindowIcon />}
                            sx={{
                                width: '100%',
                                py: 1.5,
                                borderRadius: '14px', // Square Standard
                                backgroundColor: '#0078D4', // Microsoft Blue
                                color: 'white',
                                textTransform: 'none',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#006cbd'
                                }
                            }}
                        >
                            Entrar com Microsoft
                        </Button>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default LoginPage;
